import wordCount from 'words-count';
export const WORD_COUNT_FEATURE = 'WORD_COUNT_FEATURE';
export const wordCountFeature = (editorState)=>{
    const plain = editorState.getCurrentContent().getPlainText();
    const words = wordCount(plain) || 0;
    return {
        type: WORD_COUNT_FEATURE,
        data: {
            words,
            chars: plain.length
        }
    };
};

//# sourceMappingURL=wordCount.js.map